const isBrowser = typeof window !== 'undefined';

const getGtag = () => {
  if (!isBrowser) return null;
  return typeof window.gtag === 'function' ? window.gtag : null;
};

const sanitizePath = (path) => {
  if (typeof path !== 'string' || path.length === 0) {
    return '/';
  }

  return path.startsWith('/') ? path : `/${path}`;
};

const compactParams = (params = {}) => {
  const entries = Object.entries(params).filter(([, value]) => {
    return value !== undefined && value !== null && value !== '';
  });

  return Object.fromEntries(entries);
};

export const trackPageView = (pathname) => {
  const gtag = getGtag();
  if (!gtag) return;

  gtag('event', 'page_view', {
    page_path: sanitizePath(pathname),
    page_title: document.title
  });
};

export const trackEvent = (eventName, params = {}) => {
  const gtag = getGtag();
  if (!gtag || !eventName) return;

  gtag('event', eventName, compactParams(params));
};
